import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss']
})
export class TermsDialogComponent {
  public dataset: any;
  downloading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string },
    private dialogRef: MatDialogRef<TermsDialogComponent>,
    private trustiiService: TrustiiService,
    private dialogService: DialogService
  ) {
    const defaultValues = {
      dataset: null,
    };
    const values: any = {
      ...defaultValues,
      ...data,
    };

    this.dataset = values.dataset;
  }

  closeDialog() {
    this.dialogRef.close({data: 'confirmation'});
  }

  downloadTerms() {
    this.downloading = true;
    this.trustiiService.getDatasetTerms(this.dataset.id).subscribe(
      (res) => {
        this.downloading = false;
        saveAs(res, this.dataset.displayName + '-terms.pdf');
      },
      (err) => {
        this.downloading = false;
        this.dialogService.openAlertDialog(
          '350px',
          'failed to download terms. Please retry again after sometime',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      });
  }
}
